const getStateFromUrl = (): string => {
  const params = new URL(window.location.toString()).searchParams;
  const state = params.get("state");
  if (state == "account_already_exist") {
    return `&isYoutubeAlreadyExist=true`;
  } else {
    return "";
  }
};

export default getStateFromUrl;
